import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import qs from 'qs'
import { Product, ProductConfigOption, ProductDetail } from '../types/product'

export const searchProducts = async (
    params?: object
): Promise<ResponseArray<Product>> => {
    const query = params ? `?${qs.stringify(params)}` : ''
    const response = await datacentral.get(`/products/search${query}`)
    return response.data
}

export const getProductById = async (
    productId: number
): Promise<ProductDetail> => {
    const response = await datacentral.get<ResponseObject<ProductDetail>>(
        `/products/${productId}`
    )
    return response.data.result
}

export const getProductConfigOptions = async (
    productId: number
): Promise<ProductConfigOption[]> => {
    const response = await datacentral.get<ResponseArray<ProductConfigOption>>(
        `/products/${productId}/config-options`
    )
    return response.data.results
}
